
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface SelectChildDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (childId: string) => void;
}

export const SelectChildDialog = ({ open, onClose, onSelect }: SelectChildDialogProps) => {
  const { data: children, isLoading } = useQuery({
    queryKey: ["children"],
    queryFn: async () => {
      const { data: session } = await supabase.auth.getSession();
      if (!session.session) throw new Error("No session");

      const { data, error } = await supabase
        .from("child_profiles")
        .select("*")
        .eq("parent_id", session.session.user.id);

      if (error) throw error;
      return data;
    },
  });

  const formatAge = (age: number) => {
    if (age === 0) return "0-11 months";
    return age === 1 ? "1 year old" : `${age} years old`;
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Select a Child</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          {isLoading ? (
            <p className="text-center text-gray-500">Loading children...</p>
          ) : !children?.length ? (
            <p className="text-center text-gray-500">No children found</p>
          ) : (
            children.map((child) => (
              <Button
                key={child.id}
                variant="outline"
                className="w-full justify-start text-left"
                onClick={() => onSelect(child.id)}
              >
                {child.name} - {formatAge(child.age)}
              </Button>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
